export default "__VITE_ASSET__DnLFxQJ3__"